import React, {useState} from "react";

import styles from "./Toggle.module.scss";
import classNames from "classnames";
import {IHistoryCurrentNotification, INotificationHistory, INotifications} from "../../../redux/notifications/reducer";
import {Button} from "../../commons";
import Repeat from "./Repeat";
import Stop from "./Cancel";

interface INotificationViewActions {
    notification: IHistoryCurrentNotification,
}

const NotificationViewActions: React.FC<INotificationViewActions> = ({notification}) => {

    const [isInProcessRepeating, setIsInProcessRepeating] = useState<boolean>(false);

    const repeatTaskHandler = (id: number) => {
        setIsInProcessRepeating(true);
        setTimeout(() => {
            setIsInProcessRepeating(false)
        }, 1000)
    }

    return (
        <div>
            {notification.data?.status && [3, 4, 6, 7].includes(notification.data?.status)
                ?
                <Repeat taskId={notification.data.id}></Repeat>
                :
                (notification?.data?.id && <Stop taskId={notification.data.id}></Stop>)
            }
        </div>
    )

}

export default NotificationViewActions;